export default "__VITE_ASSET__DRyfZdF$__"